<template>
  <div class="vg_wrapper">
    <add-header @submit="submit('mdopForm')" @cancel="cancel" :stateFlag="true"></add-header>
    <el-form ref="mdopForm" :model="mdopForm" label-width="160px" size="mini">
      <el-row>
        <el-col :md="8">
          <el-form-item label="产品图片" prop="imge_id" label-width="120px" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :data="dataBody"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <imgPopover v-if="mdopForm.imge_id" :imgeUrl="mdopForm.imge_url" :imgeUrlO="mdopForm.imge_urlO" />
              <i v-else class="el-icon-plus avatar-uploader-icon vg_pointer" />
            </el-upload>
            <span>仅支持jpg、png、jpeg格式且大小不能超过10MB</span>
          </el-form-item>
        </el-col>
        <el-col :md="16">
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="非毛绒打样单号" prop="requ_no" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-input v-model="mdopForm.requ_no" placeholder="请填写非毛绒打样单号" show-word-limit> </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="开模日期" prop="mdnc_date" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-date-picker value-format="timestamp" v-model="mdopForm.mdnc_date" type="date" placeholder="选择开模日期" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="我司货号" prop="smpl_no" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-input v-model="mdopForm.smpl_no" placeholder="请填我司货号" show-word-limit> </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="计划完成日期" prop="mdnc_pldate" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-date-picker value-format="timestamp" v-model="mdopForm.mdnc_pldate" type="date" placeholder="选择计划完成日期" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="模具编号" prop="mdnc_no" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-input disabled v-model="mdopForm.mdnc_no" maxlength="100" placeholder="请填写模具编号" show-word-limit>
                  <template slot="append">
                    <el-link type="primary" @click="importMdinDialog = true" class="empty vg_pointer">导入</el-link>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12" prop="purchase_id">
              <el-form-item label="采购经办人" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-select filterable v-model="mdopForm.purchase_id" placeholder="请选择采购人员" size="small" clearable>
                  <el-option v-for="(item, index) in stffType" :key="index" :label="item.stff_name" :value="item.stff_id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="模具名称" prop="mdnc_name" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-input v-model="mdopForm.mdnc_name" placeholder="请填写模具名称" show-word-limit> </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="备注" prop="mdnc_ask">
                <el-input v-model="mdopForm.mdnc_ask" placeholder="请填写" show-word-limit> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12" prop="export_id">
              <el-form-item label="外销员" :rules="[{ required: true, trigger: 'blur', message: ' ' }]">
                <el-select filterable v-model="mdopForm.export_id" placeholder="请选择采购人员" size="small" clearable>
                  <el-option v-for="(item, index) in stffType" :key="index" :label="item.stff_name" :value="item.stff_id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="vd_dash"></div>
      <el-row class="vg_mb_5">
        <!--        <el-col>
          <div class="vg_mb_16">
            <el-button type="primary" plain size="small" @click="addSubTableRow">新增</el-button>
            <el-button type="danger" plain size="small" @click="deleteRow">删除</el-button>
          </div>
        </el-col>-->
      </el-row>
      <el-row class="vg_mb_5">
        <el-col :md="24">
          <mdopPartList
            :suppList="suppList"
            ref="subTable"
            :parentForm="mdopForm"
            @handleSelectionChange="handleSelectionChange"
          ></mdopPartList>
        </el-col>
      </el-row>
      <el-row class="vg_mt_16 vd_bortop">
        <el-col>
          <inputUser :isCookie="true" ref="userData"></inputUser>
        </el-col>
      </el-row>
      <el-dialog @opened="getTableData" title="导入模具信息库" :visible.sync="importMdinDialog" width="50%">
        <el-button
          class="vg_mb_8"
          type="primary"
          size="small"
          @click="
            importMdinDialog = false;
            jump(`/mdin_add?perm_id=129`);
          "
          >新增模具信息
        </el-button>
        <search-table
          ref="searchTable"
          :data="tableData"
          :tableRowKey="'mdin_id'"
          :columns="tableProperties"
          v-loading="loadFlag"
          :totalPage="totalPage"
          @row-dblclick="dbClickJp"
          @getTableData="getTableData"
        >
        </search-table>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import { get, post } from '@api/request';
import { imgeAPI } from '@api/modules/imge';
import { mdopAPI } from '@api/modules/mdop';
import { custAPI } from '@api/modules/cust';
import { suppAPI } from '@api/modules/supp';
import { userAPI } from '@api/modules/user';
import addHeader from '@/views/component/addHeader';
import imgPopover from '@/views/component/imgPopover';
import inputUser from '@/views/component/inputUser';
import mdopPartList from '@/views/MouldManagement/MdopManage/TabChild/SubTable/MdopPartList.vue';
import SearchTable from '@/components/SearchTableV2.vue';
import { tableProperties } from '@/views/MouldManagement/MdopManage/mdop';
import { mdinAPI } from '@api/modules/mdin';
import { deleteTableRow } from '@assets/js/arrayUtils';

export default {
  name: 'mdopAddMain',
  components: {
    SearchTable,
    addHeader,
    imgPopover,
    inputUser,
    mdopPartList
  },
  data() {
    return {
      totalPage: 0,
      loadFlag: false,
      tableData: [],
      tableProperties: tableProperties,
      importMdinDialog: false,
      mdopForm: {
        imge_id: 0,
        imge_url: null,
        imge_urlO: null,
        mdnc_pdur: 0,
        mdnc_date: new Date(),
        mdnc_part_list: []
      },
      uploadUrl: this.helper.modePrepend(imgeAPI.uploadImage),
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 800,
        y: 800
      },
      imgForm: {
        imge_id: 0,
        imge_url: null,
        imge_urlO: null
      },
      custList: [],
      mouldProdList: [
        { id: 0, label: '模房' },
        { id: 1, label: '工厂' }
      ],
      mouldTypeList: [
        { id: 0, label: '生产模:P' },
        { id: 1, label: '样品模:S' }
      ],
      mdopKindList: [
        { id: 0, label: '橡胶成型模:01' },
        { id: 1, label: '橡胶硫化模:02' },
        { id: 2, label: '注塑模:03' },
        { id: 3, label: '热合模:04' },
        { id: 4, label: '辅助工具:05' }
      ],
      mouldTextList: [
        { id: 1, label: '橡胶:01' },
        { id: 2, label: 'PA6:02' },
        { id: 3, label: 'TPR:03' },
        { id: 4, label: 'TPE:04' },
        { id: 5, label: 'TPU:05' },
        { id: 6, label: 'PP:06' },
        { id: 7, label: 'ABS:07' },
        { id: 8, label: 'PET:08' },
        { id: 9, label: '吹塑EVA:09' },
        { id: 10, label: '射出EVA:10' }
      ],
      surfaceList: [
        { id: '0', label: '光面' },
        { id: '1', label: '哑面' },
        { id: '2', label: '晒纹' }
      ],
      stffType: [],
      suppList: [],
      subTableMap: new Map()
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    async getTableData() {
      await (this.loadFlag = true);
      await mdinAPI.getMdinsToMdnc(this.$refs.searchTable.searchForm).then(({ data }) => {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.loadFlag = false;
      });
    },
    dbClickJp(row) {
      let tempObj = {};
      for (const key in row) {
        tempObj[key.replaceAll('mdin', 'mdnc')] = row[key];
      }
      tempObj.mdnc_id = this.mdopForm.mdnc_id;
      tempObj.status = this.mdopForm.status;
      tempObj.mdnc_date = tempObj.opmd_date;
      tempObj.mdnc_pldate = tempObj.comp_date;
      tempObj.date = tempObj.opmd_date;
      tempObj.smpl_no = tempObj.prod_no;
      tempObj.moldinfoLists.forEach(item => {
        if (item.mdnc_part_attr.indexOf('/') !== -1) {
          item.mdnc_part_attr = item.mdnc_part_attr.split('/');
        } else if (item.mdnc_part_attr) {
          item.mdnc_part_attr = [item.mdnc_part_attr];
        }
      });
      tempObj.mdnc_part_list = tempObj.moldinfoLists;
      tempObj.imge_urlO = this.helper.picUrl(tempObj.imge_url, 'l', 0);
      tempObj.imge_url = this.helper.picUrl(tempObj.imge_url, 's', 0);
      this.mdopForm = tempObj;
      this.importMdinDialog = false;
    },
    initData() {
      this.getStffType();
      this.getCustList();
      this.getSuppList();
    },
    //提交表单
    submit(formName) {
      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.saveInfo();
          } else {
            this.$message.warning('请把必填内容补充完整');
            return false;
          }
        });
      });
    },
    // 保存
    saveInfo() {
      const staffForm = this.$refs.userData.getData();
      let mdopForm;
      mdopForm = JSON.parse(JSON.stringify(this.mdopForm));
      mdopForm = Object.assign(mdopForm, staffForm);
      mdopForm.mdnc_part_list.forEach(item => {
        item.mdnc_part_attr = item.mdnc_part_attr.join('/');
        item.mdnc_part_skin = item.mdnc_part_skin.join(',');
      });
      this.subTableMap = new Map();
      post(mdopAPI.addMdop, mdopForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            });
            const permId = this.$route.query.perm_id;
            this.jump(`/mdnc_edit?perm_id=${permId}&form_id=${res.data.data.form_id}`);
            this.resetForm('mdopForm');
          } else {
            this.$message.error(res.data.msg);
            this.initData();
          }
        })
        .catch(err => console.error(err));
    },
    //取消
    cancel() {
      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          this.resetForm('mdopForm');
          this.$router.go(-1);
          this.$message({
            type: 'info',
            message: '已取消新增!'
          });
        })
        .catch(() => {});
    },
    // 成功上传
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        this.mdopForm.imge_id = res.data.imge_id;
        let updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        let urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.mdopForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.mdopForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      } else {
        let mg = res.msg;
        let tp = 'error';
        this.$message({ message: mg, type: tp });
      }
    },
    // 上传头像前
    beforeAvatarUpload() {},
    // 获取委托人
    getStffType() {
      get(userAPI.getAllUsersV1)
        .then(res => {
          if (res.data.code === 0) {
            let stffType = res.data.data;
            let map = new Map();
            for (let item of stffType) {
              map.set(item.stff_name, item);
            }
            stffType = [...map.values()];
            this.stffType = stffType;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取客户简称
    getCustList() {
      get(custAPI.getAllCustsV1)
        .then(res => {
          if (res.data.code === 0) {
            this.custList = res.data.data.list;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取供应商
    getSuppList() {
      get(suppAPI.getSuppsV1)
        .then(res => {
          if (res.data.code === 0) {
            this.suppList = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.mdopForm.imge_id = 0;
      this.mdopForm.imge_url = null;
      this.mdopForm.imge_urlO = null;
    },
    // 子表勾选值
    handleSelectionChange(row) {
      this.selectList = JSON.parse(JSON.stringify(row));
    },
    delSubTableRow() {
      if (this.selectList.length === 0) return this.$message.warning('请至少选择一条数据!');
      let { tableData, map } = deleteTableRow('mdnc_part_id', this.mdopForm.mdnc_part_list, this.subTableMap, this.selectList);
      this.mdopForm.mdnc_part_list = tableData;
      this.subTableMap = map;
    },
    deleteRow() {
      let temp = [];
      for (let i = 0; i < this.selectList.length; i++) {
        for (let j = 0; j < this.mdopForm.mdnc_part_list.length; j++) {
          if (this.selectList[i].key === this.mdopForm.mdnc_part_list[j].key) {
            temp.push(j);
          }
        }
      }
      temp = temp.sort((a, b) => {
        return b - a;
      });
      for (let i of temp) {
        this.mdopForm.mdnc_part_list.splice(i, 1);
      }
      for (let i = 0; i < this.mdopForm.mdnc_part_list.length; i++) {
        this.mdopForm.mdnc_part_list[i].key = Number(i);
      }
    },
    // 子表新增一行空数据并增加标识
    addSubTableRow() {
      this.mdopForm.mdnc_part_list.push({
        key: this.mdopForm.mdnc_part_list.length,
        mdnc_part_attr: [{ mdnc_part_skin: [] }]
      });
      for (let i = 0; i < this.mdopForm.mdnc_part_list.length; i++) {
        this.mdopForm.mdnc_part_list[i].key = Number(i);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader ::v-deep .el-upload--text {
  width: 136px;
  height: 136px;
}

.avatar-uploader .el-upload:hover {
  border-color: $color-primary;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: $color-uploader-icon;
  width: 136px;
  height: 136px;
  line-height: 136px;
  text-align: center;
}
.vd_bortop {
  border-top: #dcdfe6 solid 1px;
  padding-top: 20px;
}
.avatar {
  width: 136px;
  height: 136px;
  display: block;
}
.vd_solidDiv {
  border-top: #848484 dashed 1px;
  margin: 10px 0 20px 0;
}
.vd_vis {
  visibility: hidden;
}
.vd_dis {
  display: flex;
  justify-content: center;
}
.vd_export {
  position: absolute;
  top: 0;
  left: 65px;
}
</style>
